<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">WebView 用ページ置き場（予定）</h1>
            <h4 class="pt-3">各ページの URL は settings.json から取得することを想定。</h4>
            <p class="text-muted">取り敢えず利用規約（のダミー）だけ置いとく。</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebViewIndex'
}
</script>



// WEBPACK FOOTER //
// src/views/_webview/WebViewIndex.vue